import { AbstractPmsApiService } from "./abstract.service";
import { SmsReminder } from "../models";

/**
 * @class SmsReminderPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<SmsReminder>}
 */
export class SmsReminderPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/sms-reminder(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SmsReminder}
     * @protected
     */
    newModel(attributes, ...params) {

        return new SmsReminder(attributes);
    }

    /**
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<SmsReminder>>}
     */
    get(params = {}) {

        const url = this.url();
        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: false
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {SmsReminder} reminder
     * @returns {Promise.<SmsReminder>}
     */
    create(reminder) {

        const url = this.url();

        return this.http
            .post(url, reminder, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {SmsReminder} reminder
     * @returns {Promise.<SmsReminder>}
     */
    update(reminder) {

        const url = this.url({id: reminder.id});

        return this.http
            .put(url, reminder, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {integer} reminderId
     * @returns {Promise.<SmsReminder>}
     */
    show(reminderId) {

        const url = this.url({
            id: reminderId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {SmsReminder} reminder
     * @returns {Promise.<boolean>}
     */
    delete(reminder) {

        const url = this.url({
            id: reminder.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    sendTestSms(template, recipients) {

        const url = this.url({id: template.id}) + '/send-test-sms';

        return this.http.post(url, recipients, {
            headers: this.authHeaders,
        })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());

    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/sms-reminder.service.js